import { Component, Input } from '@angular/core';
import { PlanningSubmissionDTO } from '../../services/api/api';

@Component({
  selector: 'sb-comp-submission-count-display',
  templateUrl: './submission-count-display.component.html',
  styleUrls: ['./submission-count-display.component.scss'],
  standalone: false,
})
export class SubmissionCountDisplayComponent {
  sumOfElements: number = 0;
  _submission: PlanningSubmissionDTO;

  @Input({ required: true }) set submission(value: PlanningSubmissionDTO) {
    this._submission = value;
    this.sumOfElements =
      value?.selectedCampaignsCount +
      value?.selectedCommercialsCount +
      value?.selectedRequirementsCount +
      value?.selectedContentSharesCount;
  }

  get submission(): PlanningSubmissionDTO {
    return this._submission;
  }
}
